import ObjectiveSpokenResultView from "./share/ObjectiveSpokenResultView";
import _ from "lodash";
import { withTranslation } from "react-i18next";
import UIDs from "../../../UIDs";

const uid = UIDs.screens.homework.resultviews.poka1resultview;

class POKA2ResultView extends ObjectiveSpokenResultView {
    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            preResult: props.result,
            ...POKA2ResultView.getInitState(props),
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.result !== state.preResult) {
            return {
                ...state,
                preResult: props.result,
                ...POKA2ResultView.getInitState(props),
            };
        }
        return null;
    }

    static getInitState(props) {
        let { paragraphs = [], practiceRole = 1 } = props.data || {};
        let dialogs = _.flatMap(paragraphs, p => p.sentences).map(sentence => ({ role: 1, sentence }));
        return this.getDialogState(props, dialogs, practiceRole, _.cloneDeep(props.result));
    }
}

export default withTranslation(uid)(POKA2ResultView);
